<template>
  <div class="order-container">
    <el-header>
      <div class="header-content">
        <el-button 
          icon="el-icon-back" 
          @click="goBack" 
          class="back-button"
        >
          Back
        </el-button>
        <h1>Order Details</h1>
      </div>
    </el-header>
    <el-main>
      <el-card class="order-card">
        <div class="bundle-preview">

          <div v-if="previewCollections && previewCollections.length > 0" class="collections-container">
            <div
              v-for="(collection, index) in previewCollections"
              :key="collection._id ? (collection._id.$oid || collection._id.$id) : index"
              class="collection-preview-item"
            >
              <el-image
                v-if="collection.cover_url"
                :src="collection.cover_url"
                fit="cover"
                class="cover-image"
              >
                <div slot="error" class="image-placeholder">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div v-else class="image-placeholder">
                <i class="el-icon-picture-outline"></i>
              </div>
            </div>
            <div v-if="remainingCollections > 0" class="more-collections">
              +{{ remainingCollections }} more collections
            </div>
          </div>

        

          <div class="bundle-info">
            <h2>{{ bundle.bundle_name }}</h2>
            <p class="author">
              <span>By </span>
              <el-avatar
                :size="24"
                :src="bundle.user_avatar_address_small"
                :style="{
                  marginRight: '8px',
                  verticalAlign: 'middle',
                  backgroundColor: bundle.user_avatar_address_small && bundle.user_avatar_address_small !== '' && bundle.user_avatar_address_small !== 'undefined' ? 'white' : '#e0e0e0',
                  border: getBorderStyleByUserType(bundle.user_type),
                  fontSize: '14px',
                  color: '#409EFF'
                }"
              >
                {{ bundle.user_avatar_address_small && bundle.user_avatar_address_small !== '' && bundle.user_avatar_address_small !== 'undefined' ? '' : bundle.user_name?.charAt(0) }}
              </el-avatar>
              <span style="vertical-align: middle;">{{ bundle.user_name }}</span>
            </p>
            <div class="bundle-stats">
              
            </div>
          </div>
        </div>

        <div class="order-details">
          <div class="price-section">
            <div class="price-row">
              <h3>Price</h3>
              <div class="price-amount">
                <span>FREE</span>
              </div>
            </div>
            <div class="price-row total-row">
              <h3>Total</h3>
              <div class="price-amount total-price">
                <span>$0.00</span>
              </div>
            </div>
          </div>

          <div class="order-summary">
            <h3>Order Summary</h3>
            <div class="summary-item">
              <span>Order Time</span>
              <span>{{ formatDate(new Date()) }}</span>
            </div>
            <div class="summary-item">
              <span>Order Status</span>
              <el-tag size="small" type="warning">Pending Payment</el-tag>
            </div>
          </div>

          <div class="payment-section">
            <el-button 
              type="primary" 
              :loading="creating" 
              @click="createOrder"
              style="width: 100%"
            >
              Confirm and Claim Free
            </el-button>
            <p class="payment-note">
              <span>By proceeding, you agree to our <a href="#">User Policy</a> and <a href="#">Terms of Service</a>. Requires active platform subscription.</span>
            </p>
          </div>
        </div>
      </el-card>
    </el-main>
  </div>
</template>

<script>
import { postRequest } from '@/apis/front'

export default {
  name: 'BundleOrder',
  data() {
    return {
      bundle: {},
      creating: false
    }
  },
  created() {
    this.fetchBundleData()
  },
  beforeDestroy() {
    // Clean up the temporary bundle ID from store
    this.$store.dispatch('setTempBundleId', null)
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString()
    },
    async fetchBundleData() {
      try {
        const bundleId = this.$store.state.tempBundleId || this.$route.query.id
        
        if (!bundleId) {
          this.$message.error('Bundle ID not found')
          this.$router.go(-1)
          return
        }
        
        const response = await postRequest('getCollectionBundle', {
          bundle_id: bundleId,
          user_id: this.$store.state.user_id
        })
        
        if (response.data.code === 0) {
          this.bundle = response.data.data
          console.log('Bundle data:', this.bundle)
          console.log('Collection array:', this.bundle.collection_array)
          console.log('Preview collections:', this.previewCollections)
        } else {
          this.$message.error(response.data.msg || 'Failed to load bundle')
        }
      } catch (error) {
        this.$message.error('Failed to load bundle')
      }
    },
    async createOrder() {
      // Check subscription before claiming
      const subscription = this.$store.state.platformSubscription
      if (!subscription || !subscription.active) {
        this.$confirm(
          'An active platform subscription is required to claim content. Would you like to subscribe now?',
          'Subscription Required',
          {
            confirmButtonText: 'Subscribe Now',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        ).then(() => {
          this.$router.push('/platform-subscription')
        }).catch(() => {})
        return
      }

      this.creating = true
      try {
        const bundleId = this.bundle._id?.$oid || this.bundle._id?.$id || this.$store.state.tempBundleId || this.$route.query.id || this.$route.query.bundle_id

        if (!bundleId) {
          this.$message.error('Bundle ID not found')
          return
        }

        const response = await postRequest('createBundleOrder', {
          user_id: this.$store.state.user_id,
          bundle_id: bundleId,
          usd_price: this.bundle.bundle_usd_price
        })
        
        if (response.data.code === 0 && response.data.data.status === 'PENDING') {
          this.$message.success('Order created successfully')
          this.$router.push({
            path: '/pay',
            query: {
              order_id: (response.data.data._id.$oid || response.data.data._id.$id),
              order_type: "bundle"
            }
          })
        } else if (response.data.code === -2 || (response.data.code === 0 && response.data.data.status === 'COMPLETE')) {
          this.$message.warning('You have already purchased this bundle')
          this.$store.dispatch('setTempBundleId', bundleId)
          this.$router.push('/bundle')
        } else {
          throw new Error(response.data.msg || 'Failed to create order')
        }
      } catch (error) {
        this.$message.error(error.message || 'Failed to create order')
      } finally {
        this.creating = false
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    getBorderStyleByUserType(userType) {
      // Default to Individual if not set
      const type = userType || 'individual';
      
      switch(type) {
        case 'individual':
          return '1px solid #1890ff'; // Theme blue border
        case 'institution':
          return '1px solid #67C23A'; // Green border for institutions
        case 'agent':
          return '1px solid #E6A23C'; // Orange border for agents
        default:
          return '1px solid #e0e0e0'; // Default gray border
      }
    }
  },
  computed: {
    previewCollections() {
      if (!this.bundle.collection_array) return []
      return Object.values(this.bundle.collection_array).slice(0, 3)
    },
    remainingCollections() {
      if (!this.bundle.collection_array) return 0
      return Math.max(0, Object.values(this.bundle.collection_array).length - 3)
    }
  }
}
</script>

<style scoped>
.order-container {
  width: 100%;
}

.el-header {
  background: #409EFF;
  color: white;
  padding: 0;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.header-content {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  justify-content: flex-start;
  position: relative;
}

.header-content h1 {
  flex: 1;
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  margin: 0;
  color: white;
}

.back-button {
  margin-left: 16px;
  color: white;
  border: none;
  background: transparent;
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.1);
}

.order-card {
  width: 70%;
  margin: 20px auto;
  padding: 30px;
  text-align: left;
}

.bundle-preview {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px;
  border-bottom: 1px solid #EBEEF5;
  position: relative;
  text-align: left;
}

.collections-container {
  display: flex;
  gap: 12px;
  padding: 12px 0;
}

.collection-preview-item {
  width: 100px;
  height: 150px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  transition: all 0.3s;
  background: #f5f7fa;
  cursor: pointer;
  flex-shrink: 0;
  position: relative;
}

.collection-preview-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px 0 rgba(0,0,0,0.15);
}

.cover-image {
  width: 100%;
  height: 100%;
}

.cover-image :deep(img) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  color: #909399;
  font-size: 24px;
}

.more-collections {
  height: 150px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background-color: #409EFF15;
  border-radius: 8px;
  color: #409EFF;
  font-size: 14px;
  font-weight: 500;
}

.empty-preview {
  width: 300px;
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  border-radius: 8px;
  color: #909399;
}

.empty-preview i {
  font-size: 32px;
  margin-bottom: 8px;
}

.cover-image {
  width: 150px;
  height: 212px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f5f7fa;
}

.cover-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bundle-info {
  flex: 1;
  text-align: left;
}

.bundle-info h2 {
  margin: 0 0 10px;
  font-size: 24px;
}

.author {
  color: #606266;
  margin: 5px 0;
}

.bundle-stats {
  margin-top: 16px;
  color: #606266;
  display: flex;
  gap: 16px;
}

.stat-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.stat-item i {
  font-size: 16px;
}

.bundle-stats span {
  color: #909399;
  display: flex;
  align-items: center;
  gap: 5px;
}

.order-details {
  margin-top: 30px;
}

.price-section {
  margin-bottom: 30px;
}

.price-amount {
  font-size: 24px;
  color: #303133;
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.original-price {
  text-decoration: line-through;
  color: #909399;
  font-size: 0.8em;
}

.final-price {
  color: #409EFF;
  font-weight: bold;
}

.savings {
  font-size: 0.7em;
  color: #67C23A;
  background-color: #f0f9eb;
  padding: 2px 8px;
  border-radius: 4px;
}

.order-summary {
  margin-bottom: 30px;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
  color: #606266;
}

.payment-section {
  margin-top: 30px;
}

.payment-note {
  margin-top: 15px;
  color: #909399;
  font-size: 14px;
  text-align: center;
}

.payment-note a {
  color: #409EFF;
  text-decoration: none;
}

.placeholder-cover {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #C0C4CC;
  font-size: 40px;
}
</style>
